<template>
  <p class="summary" :class="{ 'summary--error': isError }" role="status" aria-live="polite">{{ text }}</p>
</template>

<script setup>
  import { computed } from 'vue';
  import { useBriefcaseState } from '@/Groups/Briefcase/private/composables/computedValues';
  import { WEIGHT_STATUS, formatShare } from '@/Groups/Briefcase/private/utils/resolveWeights';
  //------------------------
  const { weightState, weightsError, coinAssets } = useBriefcaseState();
  //------------------------
  const symbolById = computed(() => Object.fromEntries(coinAssets.value.map(item => [item.coin.api_id, item.coin.symbol])));
  //Склонение «монета»
  const coinsWord = (n) => {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return 'монету';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'монеты';
    return 'монет';
  };
  //Ошибка ввода или сумма > 100 подсвечиваются красным
  const isError = computed(() => Boolean(weightsError.value) || weightState.value.hasInvalid || weightState.value.status === WEIGHT_STATUS.OVER);
  //Текст подсказки под списком
  const text = computed(() => {
    const { status, total, blankCount, shares, hasInvalid } = weightState.value;
    if (weightsError.value) return weightsError.value;
    if (hasInvalid) return 'Доля — число от 0 до 100';
    if (status === WEIGHT_STATUS.OVER) return `Итого ${formatShare(total)}% — больше 100%`;
    if (status === WEIGHT_STATUS.REMAINDER) {
      return `Указано ${formatShare(total)}% · остаток ${formatShare(100 - total)}% поровну на ${blankCount} ${coinsWord(blankCount)}`;
    }
    if (status === WEIGHT_STATUS.SCALED) {
      const scaled = Object.entries(shares).map(([id, share]) => `${symbolById.value[id]} ${formatShare(share)}`).join(' · ');
      return `Итого ${formatShare(total)}%. В расчёте доли масштабируются до 100%: ${scaled}`;
    }
    if (status === WEIGHT_STATUS.EXACT) return 'Итого 100%';
    return 'Доли не указаны — у всех монет равный вес';
  });
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>
